
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsArchiveSection() {
  const [selectedYear, setSelectedYear] = useState('2025');
  const [selectedMonth, setSelectedMonth] = useState('January');

  const years = ['2025', '2024', '2023', '2022'];
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const archiveData = {
    '2025': {
      'January': [
        { title: 'Federal Healthcare Investment Announcement', category: 'Policy', date: 'Jan 16' },
        { title: 'Ontario Mental Health Prescribing Expansion', category: 'Policy', date: 'Jan 15' },
        { title: 'Veterinary Telehealth Milestone', category: 'Community', date: 'Jan 14' },
        { title: 'Collaborative Care Research Results', category: 'Research', date: 'Jan 13' },
        { title: 'Indigenous Health Scholarship Launch', category: 'Education', date: 'Jan 12' }
      ]
    },
    '2024': {
      'December': [
        { title: 'Year-End Policy Review', category: 'Policy', date: 'Dec 28' },
        { title: 'Holiday Practice Guidelines', category: 'Education', date: 'Dec 20' },
        { title: 'Community Health Achievements', category: 'Community', date: 'Dec 15' }
      ]
    }
  };

  const currentArchive = archiveData[selectedYear]?.[selectedMonth] || [];

  const categories = [
    { name: 'Policy Updates', count: 45, color: 'bg-blue-100 text-blue-800' },
    { name: 'Research & Studies', count: 28, color: 'bg-green-100 text-green-800' },
    { name: 'Community Stories', count: 35, color: 'bg-purple-100 text-purple-800' },
    { name: 'Educational Resources', count: 52, color: 'bg-orange-100 text-orange-800' },
    { name: 'Event Announcements', count: 19, color: 'bg-red-100 text-red-800' },
    { name: 'Industry News', count: 31, color: 'bg-indigo-100 text-indigo-800' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            News Archive
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse our comprehensive archive of healthcare news, policy updates, and industry developments
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Archive Browser */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex flex-col sm:flex-row gap-4 mb-6">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Year</label>
                  <select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8"
                  >
                    {years.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Month</label>
                  <select
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8"
                  >
                    {months.map(month => (
                      <option key={month} value={month}>{month}</option>
                    ))}
                  </select>
                </div>
                <div className="flex items-end">
                  <Button className="bg-blue-600 hover:bg-blue-700 whitespace-nowrap">
                    <i className="ri-search-line mr-2"></i>
                    Search
                  </Button>
                </div>
              </div>

              <div className="space-y-4">
                {currentArchive.length > 0 ? (
                  currentArchive.map((item, index) => (
                    <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                          <div className="flex items-center space-x-3">
                            <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                              item.category === 'Policy' ? 'bg-blue-100 text-blue-800' :
                              item.category === 'Research' ? 'bg-green-100 text-green-800' :
                              item.category === 'Community' ? 'bg-purple-100 text-purple-800' :
                              'bg-orange-100 text-orange-800'
                            }`}>
                              {item.category}
                            </span>
                            <span className="text-sm text-gray-500">{item.date}</span>
                          </div>
                        </div>
                        <Button variant="outline" size="sm" className="whitespace-nowrap">
                          View
                        </Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-8">
                    <i className="ri-file-list-line text-4xl text-gray-400 mb-4"></i>
                    <p className="text-gray-500">No articles found for {selectedMonth} {selectedYear}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Category Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Browse by Category</h3>
              <div className="space-y-3">
                {categories.map((category, index) => (
                  <div key={index} className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors">
                    <div className="flex items-center space-x-3">
                      <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${category.color}`}>
                        {category.name}
                      </span>
                    </div>
                    <span className="text-sm font-semibold text-gray-600">{category.count}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Search Archive */}
            <div className="bg-blue-50 rounded-xl p-6 mt-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Search Archive</h3>
              <div className="space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder="Search articles..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Author name..."
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <Button className="w-full bg-blue-600 hover:bg-blue-700 whitespace-nowrap">
                  Advanced Search
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
